document.addEventListener('click', function (e) {
  if (!e.target.classList.contains('tab-btn')) return;

  const wrapper = e.target.closest('.product-tabs');
  if (!wrapper) return;

  const buttons = wrapper.querySelectorAll('.tab-btn');
  const contents = wrapper.querySelectorAll('.tab-content');

  buttons.forEach(b => b.classList.remove('active'));
  contents.forEach(c => c.classList.remove('active'));

  e.target.classList.add('active');
  wrapper.querySelector('#' + e.target.dataset.tab).classList.add('active');
});
